<!-- <div class="list-group list-group-flush">
    <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/invoicing/carrier"]'>Carriers</a>
    <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/invoicing/customer-invoice"]'>Customer Invoices</a>

</div> -->

    <!-- <a class="list-group-item list-group-item-action" [routerLinkActive]='["active"]' [routerLink]='["/invoicing/client"]'>Clients</a> -->

    <mat-accordion *ngIf = 'this.role == "Admin"' class="container-accordion" multi = "true">
        <mat-expansion-panel *ngFor="let item of adminmenuOptions"
        class="expansion-panel" [expanded] = "item"
        >
          <mat-expansion-panel-header  >
      <mat-panel-title>
        <div style = "font-weight: 500;">
      
         {{item.title}} 
        </div>
      </mat-panel-title>
      
          </mat-expansion-panel-header>
          <ng-container *ngFor="let subItem of item.subItems" >
      
            <div class="submenu" >
              <a style = "color: black" href="{{ subItem.path }}">{{ subItem.name }}</a
              >
            </div>
      
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf = 'this.role !== "Admin"'class="container-accordion" multi = "true">
        <mat-expansion-panel *ngFor="let item of usermenuOptions"
        class="expansion-panel" [expanded] = "item"
        >
          <mat-expansion-panel-header  >
      <mat-panel-title>
        <div style = "font-weight: 500;">
      
         {{item.title}} 
        </div>
      </mat-panel-title>
      
          </mat-expansion-panel-header>
          <ng-container *ngFor="let subItem of item.subItems" >
      
            <div class="submenu" >
              <a style = "color: black" href="{{ subItem.path }}">{{ subItem.name }}</a
              >
            </div>
      
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>